import { useTranslation } from "../i18n/LanguageContext";
import { Globe } from "lucide-react";

export function LanguageSelector({ className = "" }) {
  const { lang, setLang } = useTranslation();

  return (
    <button
      onClick={() => setLang(lang === "fr" ? "en" : "fr")}
      className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-full text-xs font-medium border border-stone-200 hover:border-[#E8175D] hover:text-[#E8175D] transition-colors ${className}`}
      data-testid="language-selector"
      title={lang === "fr" ? "Switch to English" : "Passer en français"}
    >
      <Globe className="w-3.5 h-3.5" />
      {lang === "fr" ? "EN" : "FR"}
    </button>
  );
}
